module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAMCAYAAAAK/x/DAAAA2klEQVQ4T7WUvQrCMBSFzxEXd4Xa57Kjs2ClFnTwDdy0FCo4O9bnsoW6u/VKCxVU+pOEZA33no8vhxCGx73KVF5YVms4we2x4tNkJU2GnVgWFFxEMKuBiEKIdR7wrrtXC8iJZYYSCQCvJTjFCH4esFAFUwb6tdIWqGtrMNAAK21sSrYGATmReCSSpivKz1B1S+DnIdO+2U4gAyvatlqBTK10dqvD1h+QBStKtr6AbFlRsfUBmkdyEODYVzob9yR22Zan+nNtAtxINiVwBjC2EdqxsySwz0JW2XgDknNiDVDjDGsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_arrows_up.png
// module id = rAEJ
// module chunks = 96